import { TCatalogFilter } from './catalog-filters';

/** Where an entry point wants to land on the Menú page. */
export interface IMenuPageTarget {
  filter?: TCatalogFilter;
  cId?: number;
  item?: 'new';
  category?: 'new';
}

/**
 * The link of an entry point (dashboard, setup, importer) to the store's
 * menu (plan §5.1): the Menú page with its deep-link query when V2 is on,
 * otherwise the legacy «Items» / «Categorías» pages.
 */
export function menuPagePath(
  stringId: string,
  v2: boolean,
  target: IMenuPageTarget = {}
): string {
  if (!v2) {
    if (target.category) return `/${stringId}/categories`;
    return target.cId !== undefined
      ? `/${stringId}/items?cId=${target.cId}`
      : `/${stringId}/items`;
  }

  const query: string[] = [];
  if (target.filter && target.filter !== 'all')
    query.push(`filter=${target.filter}`);
  if (target.cId !== undefined) query.push(`cId=${target.cId}`);
  if (target.item) query.push(`item=${target.item}`);
  if (target.category) query.push(`category=${target.category}`);
  return `/${stringId}/menu${query.length ? `?${query.join('&')}` : ''}`;
}

/** The storefront's product address (D-RT-1): opens the item sheet over the carta. */
export function storefrontItemUrl(
  domain: string,
  stringId: string,
  itemId: number
): string {
  return `https://${domain}/${encodeURIComponent(stringId)}/item/${itemId}`;
}
